import { createSlice } from '@reduxjs/toolkit';

const variable = { id: "", code: "", name: "" }

const initialState = {
    color: { ...variable, hexCode: "" },
    pattern: { ...variable },
    collection: { ...variable, type: "" },
    product: {
        id: "",
        color: null,
        weight: null,
        pattern: null,
        name: "",
        description: ""
    },
    cheque: {
        id: "",
        owner: "",
        serialNumber: "",
        isEnabled: true,
    },
    order: {
        id: "",
        customer: null,
        orderDate: "",
        invoiceNumber: "",
        product: null,
        boilerCode: ""
    },
    payment: {
        id: "",
        partner: ""
    },
    roll: {
        id: "",
        product: null,
        location: null,
        boilerCode: "",
        upc: "",
        collection: null,
        color: null,
        hasMore: true
    },
    purchase: {
        supplier: null,
        invoiceNumber: ""
    },
    productionRecord: {
        id: "",
        outsourcer: null
    }
}

const searchParamsSlice = createSlice({
    name: 'searchParams',
    initialState,
    reducers: {
        setColorSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.color = { ...state.color, [key]: value }
        },
        setPatternSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.pattern = { ...state.pattern, [key]: value }
        },
        setCollectionSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.collection = { ...state.collection, [key]: value }
        },
        setProductSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.product = { ...state.product, [key]: value }
        },
        setChequeSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.cheque = { ...state.cheque, [key]: value }
        },
        setOrderSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.order = { ...state.order, [key]: value }
        },
        setPaymentSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.payment = { ...state.payment, [key]: value }
        },
        setRollSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.roll = { ...state.roll, [key]: value }
        },
        setPurchaseSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.purchase = { ...state.purchase, [key]: value }
        },
        setproductionRecordSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.productionRecord = { ...state.productionRecord, [key]: value }
        },
    },
});

export const {
    setColorSearchParamsAction,
    setPatternSearchParamsAction,
    setCollectionSearchParamsAction,
    setProductSearchParamsAction,
    setChequeSearchParamsAction,
    setOrderSearchParamsAction,
    setPaymentSearchParamsAction,
    setRollSearchParamsAction,
    setPurchaseSearchParamsAction,
    setproductionRecordSearchParamsAction } = searchParamsSlice.actions;
export default searchParamsSlice;